import { useIntl } from "react-intl";

import { XMarkIcon } from "components/Icons";
import { STYLE_FOCUS_RING } from "../constants";

function RecordTag({ record, onRemove }) {
  const intl = useIntl();
  return (
    <li className="flex min-h-9 max-w-full items-center gap-1 rounded-full bg-sky-50 pl-3 pr-1 text-sm text-sky-900">
      <span className="truncate">{record.rec_name}</span>
      <button
        type="button"
        aria-label={intl.formatMessage(
          { id: "melhous.dash.list.remove_tag" },
          { name: record.rec_name },
        )}
        onClick={() => onRemove(record)}
        className={`flex size-7 shrink-0 items-center justify-center rounded-full hover:bg-sky-100 ${STYLE_FOCUS_RING}`}
      >
        <XMarkIcon width={14} className="fill-current" />
      </button>
    </li>
  );
}

export default RecordTag;
